<template>
    <div class="page-header-wrapper">
        <!-- Decorative shapes -->
        <div class="decoration-shape shape-bottom-left"></div>
        <div class="decoration-shape shape-bottom-right"></div>
        <div class="decoration-shape shape-top-right"></div>
        
        <!-- Slot for Navbar -->
        <slot name="navbar"></slot>
        
        <!-- Slot for PageTitle -->
        <slot name="pagetitle"></slot>
    </div>
</template>

<script>
export default {
    name: 'PageHeader'
}
</script>

<style scoped>
.page-header-wrapper {
    position: relative;
    background: linear-gradient(97deg, #F3F9FE 13.94%, #FFF 77.48%);
    overflow: hidden;
    height: 436px;
}

/* Bottom-left decorative shape */
.shape-bottom-left {
    position: absolute;
    bottom: -325px;
    left: -250px;
    width: 599.353px;
    height: 675.877px;
    transform: rotate(42.439deg);
    flex-shrink: 0;
    border-radius: 675.877px;
    background: #B9ECFF;
    filter: blur(150px);
    z-index: 0;
    pointer-events: none;
}

/* Bottom-right decorative shape */
.shape-bottom-right {
    position: absolute;
    top: 243px;
    right: -181px;
    width: 439px;
    height: 356px;
    flex-shrink: 0;
    border-radius: 439px;
    background: radial-gradient(58.97% 44.62% at 36.79% 41.56%, #EED1E7 0%, #D2D3FC 100%);
    filter: blur(115.1500015258789px);
    z-index: 0;
    pointer-events: none;
}

/* Top-right decorative shape */
.shape-top-right {
    position: absolute;
    top: -167px;
    right: 71px;
    width: 758px;
    height: 706px;
    flex-shrink: 0;
    border-radius: 758px;
    background: radial-gradient(135.19% 91.5% at -35.46% 47.81%, rgba(201, 183, 255, 0.11) 0%, rgba(11, 113, 250, 0.11) 100%);
    filter: blur(115.1500015258789px);
    z-index: 0;
    pointer-events: none;
}

/* Ensure slots content is above decorative shapes */
/* .page-header-wrapper > * {
    position: relative;
    z-index: 1;
} */
</style>

